<template>
  <div class="px-5">
    <v-col cols="12" class="py-0 group-bread-scrumb">
      <router-link :to="{ name: 'Product' }"> Quản lý sản phẩm </router-link>
      <span> > </span>
      <router-link :to="''"> Chính sách giá và thời hạn </router-link>
    </v-col>
    <div class="create-form">
      <v-col cols="12">
        <div class="group-form">
          <v-row>
            <v-col cols="12 py-0 pt-2 px-8">
              <h3>Chính sách giá và thời hạn</h3>
            </v-col>
            <v-col class="py-0 px-8 pb-3 pt-3 table-product" cols="5">
              <v-simple-table class="table-layout table-custom table-sku">
                <thead>
                  <tr>
                    <th class="col-code">Mã SKU</th>
                    <th class="col-name">Tên SKU</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="sku">
                    <td>{{ sku.code }}</td>
                    <td>
                      <span style="font-weight: bold">{{ sku.name }}</span>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col class="py-0 px-8 pt-3 pb-3 table-product" cols="12">
              <v-simple-table class="table-sku table-policies">
                <thead>
                  <tr class="">
                    <th class="col-start text-center">Ngày bắt đầu*</th>
                    <th class="col-end text-center">Ngày kết thúc</th>
                    <th class="col-org-price text-center">Giá combo gốc</th>
                    <th class="col-price-type">Loại giá bán*</th>
                    <th class="col-min-price text-center">
                      Giá bán tối thiểu*
                    </th>
                    <th class="col-max-price text-center">
                      Giá bán tối đa<span v-if="priceType === 'custom'">*</span>
                    </th>
                    <th class="col-product-type">Loại sản phẩm</th>
                    <th class="col-sku-code">Mã SKU</th>
                    <th class="col-product-name">Tên sản phẩm</th>
                    <th class="col-type">Loại thời hạn</th>
                    <th
                      class="col-gift text-center"
                      style="min-width: 120px !important"
                    >
                      Thời hạn tặng thêm*
                    </th>
                    <th class="col-status">Trạng thái</th>
                    <th class="col-create-by text-center">Người tạo</th>
                    <th class="col-action text-center">Thao tác</th>
                  </tr>
                </thead>
                <tbody :key="keyRender">
                  <tr>
                    <td>
                      <date-picker
                        :disabled="isExistPending"
                        class="datetime-custom"
                        format="DD-MM-YYYY HH:mm"
                        :minute-options="[]"
                        v-model="startDate"
                        type="datetime"
                        :editable="isEditable"
                        placeholder="Ngày bắt đầu"
                      ></date-picker>
                    </td>
                    <td>
                      <date-picker
                        :disabled="isExistPending"
                        class="datetime-custom"
                        format="DD-MM-YYYY HH:mm"
                        :minute-options="[]"
                        v-model="endDate"
                        type="datetime"
                        :editable="isEditable"
                        placeholder="Ngày kết thúc"
                      ></date-picker>
                    </td>
                    <td class="text-center" v-if="sku">
                      {{ formatCurrency(sku.comboPrice) }}
                    </td>
                    <td class="pt-6">
                      <v-select
                        :disabled="isExistPending"
                        class="text-field v-select-custom-combo"
                        :items="priceTypes"
                        item-value="id"
                        item-text="name"
                        :aLight="'right'"
                        placeholder="Chọn loại giá bán"
                        attach
                        outlined
                        dense
                        v-model="priceType"
                        :menu-props="{
                          bottom: true,
                          offsetY: true,
                          maxHeight: '150',
                        }"
                      ></v-select>
                    </td>
                    <td class="pt-6">
                      <v-text-field
                        :disabled="isExistPending"
                        class="text-field text-field-number"
                        :clearable="true"
                        placeholder="Nhập giá bán tối thiểu"
                        outlined
                        dense
                        type="number"
                        v-model="minPrice"
                        min="0"
                      ></v-text-field>
                    </td>
                    <td class="pt-6 text-center">
                      <span v-if="priceType != 'custom'">--</span>
                      <v-text-field
                        :disabled="isExistPending"
                        v-if="priceType == 'custom'"
                        class="text-field text-field-number"
                        :clearable="true"
                        placeholder="Nhập giá bán tối đa"
                        outlined
                        dense
                        min="0"
                        type="number"
                        v-model="maxPrice"
                      ></v-text-field>
                    </td>
                    <td colspan="5" class="px-0">
                      <div
                        v-for="(
                          detailPolicy, indexDt
                        ) in comboPricePolicyDetails"
                        :key="'dtt' + indexDt"
                        class="d-flex"
                        :class="{
                          'item-sku-detail':
                            indexDt != comboPricePolicyDetails.length - 1,
                        }"
                      >
                        <div class="group-type-sku pl-4 py-5">
                          {{ detailPolicy.typeTitle }}
                        </div>
                        <div class="group-code pl-4 py-5">
                          {{ detailPolicy.code }}
                        </div>
                        <div class="group-name pl-4 py-5">
                          {{ detailPolicy.name }}
                        </div>
                        <div class="group-type pl-4 py-5">
                          <span>{{ detailPolicy.typeDuration }}</span>
                        </div>
                        <div class="group-additional px-4 py-3 text-center">
                          <span
                            v-if="
                            	detailPolicy.typeDuration == 'Theo ngày' && detailPolicy.type == 'duo'
                            "
                            >--</span>
                          <v-text-field
                            v-else
                            :disabled="isExistPending"
                            class="text-field text-field-no-message text-field-number"
                            :clearable="true"
                            placeholder="Nhập"
                            outlined
                            dense
                            type="number"
                            min="0"
                            max="999"
                            v-model="detailPolicy.additionalDuration"
                          ></v-text-field>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">--</td>
                    <td class="text-center">
                      {{ userId }}
                    </td>
                    <td class="text-center">
                      <v-tooltip bottom class="mr-2">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :disabled="isExistPending"
                            color="#329D20"
                            v-bind="attrs"
                            v-on="on"
                            @click="addPolicy"
                          >
                            mdi-check-circle
                          </v-icon>
                        </template>
                        <span>Thêm</span>
                      </v-tooltip>
                    </td>
                  </tr>
                  <tr v-if="!data.length">
                    <td colspan="14">Không có dữ liệu</td>
                  </tr>
                  <tr
                    v-for="(item, index) in data"
                    :key="index"
                    @dblclick="showEdit(item, index)"
                  >
                    <td class="text-center">
                      <span v-if="!item.isEdit">{{
                        dateCus(item.startDate)
                      }}</span>
                      <date-picker
                        v-if="item.isEdit"
                        class="datetime-custom"
                        format="DD-MM-YYYY HH:mm"
                        v-model="item.startDate"
                        :minute-options="[]"
                        type="datetime"
                        :editable="isEditable"
                        :disabled="item.status != 'pending'"
                        placeholder="Ngày bắt đầu"
                      ></date-picker>
                    </td>
                    <td class="text-center">
                      <span v-if="!item.isEdit">{{
                        item.endDate ? dateCus(item.endDate) : "--"
                      }}</span>
                      <date-picker
                        v-if="item.isEdit"
                        class="datetime-custom"
                        format="DD-MM-YYYY HH:mm"
                        v-model="item.endDate"
                        :minute-options="[]"
                        type="datetime"
                        :editable="isEditable"
                        :disabled="isDisableEndDate(item)"
                        placeholder="Ngày kết thúc"
                      ></date-picker>
                    </td>
                    <td class="text-center">
                      <span v-if="sku">{{
                        item.orgPrice
                          ? formatCurrency(item.orgPrice)
                          : formatCurrency(sku.comboPrice)
                      }}</span>
                    </td>
                    <td>
                      <span v-if="!item.isEdit">
                        <span
                          v-for="(type, idt) in priceTypes"
                          :key="index + '' + idt"
                        >
                          <span v-if="type.id === item.priceType">{{
                            type.name
                          }}</span>
                        </span>
                      </span>
                      <v-select
                        v-if="item.isEdit"
                        class="text-field v-select-custom-combo mt-5"
                        :items="priceTypes"
                        item-value="id"
                        item-text="name"
                        :aLight="'right'"
                        placeholder="Chọn loại giá bán"
                        attach
                        outlined
                        dense
                        v-model="item.priceType"
                        @change="item.maxPrice = null"
                        :disabled="item.status != 'pending'"
                        :menu-props="{
                          bottom: true,
                          offsetY: true,
                          maxHeight: '150',
                        }"
                      ></v-select>
                    </td>
                    <td class="text-center">
                      <span v-if="!item.isEdit">{{
                        formatCurrency(item.minPrice)
                      }}</span>
                      <v-text-field
                        v-if="item.isEdit"
                        class="text-field mt-5 text-field-number"
                        :clearable="true"
                        placeholder="Nhập giá bán tối thiểu"
                        outlined
                        dense
                        type="number"
                        v-model="item.minPrice"
                        :disabled="item.status != 'pending'"
                        min="0"
                      ></v-text-field>
                    </td>
                    <td class="text-center">
                      <span
                        v-if="!item.isEdit || item.priceType == 'unchanged'"
                        >{{
                          item.maxPrice ? formatCurrency(item.maxPrice) : "--"
                        }}</span
                      >
                      <v-text-field
                        v-if="item.priceType == 'custom' && item.isEdit"
                        class="text-field mt-5 text-field-number"
                        :clearable="true"
                        placeholder="Nhập giá bán tối đa"
                        outlined
                        dense
                        min="0"
                        type="number"
                        v-model="item.maxPrice"
                        :disabled="item.status != 'pending'"
                      ></v-text-field>
                    </td>
                    <td colspan="5" class="px-0">
                      <div
                        v-for="(
                          detailPolicy, indexDt
                        ) in item.pricePolicyDetails"
                        :key="index + 'dt' + indexDt"
                        :class="{
                          'item-sku-detail':
                            indexDt != item.pricePolicyDetails.length - 1,
                        }"
                        class="d-flex"
                      >
                        <div class="group-type-sku pl-4 py-3">
                          {{
                            detailPolicy.itemType == "tutor" ? "Gia sư" : "Khóa học"
                          }}
                        </div>
                        <div class="group-code pl-4 py-3">
                          {{
							findSkuDetailById(detailPolicy) ? findSkuDetailById(detailPolicy).code : '--'
                          }}
                        </div>
                        <div class="group-name pl-4 py-3">
                          {{
                            findSkuDetailById(detailPolicy) ? findSkuDetailById(detailPolicy).name : '--'
                          }}
                        </div>
                        <div class="group-type pl-4 py-3">
                          <span v-if="detailPolicy.itemType == 'tutor'"
                            >Theo buổi</span
                          >
                          <span v-else>{{
                            detailPolicy.durationType == "month"
                              ? "Theo tháng"
                              : "Theo ngày"
                          }}</span>
                        </div>
                        <div class="group-additional pl-4 py-3 text-center">
                          <span
                            v-if="
                            	detailPolicy.durationType == 'day' && detailPolicy.itemType == 'duo'
                            "
                            >--</span>
                          <v-text-field
                            v-if="detailPolicy.type != 'duo' && detailPolicy.durationType !== 'day'"
                            class="text-field text-field-no-message text-field-number"
                            :clearable="true"
                            placeholder="Nhập"
                            outlined
                            dense
                            type="number"
                            min="0"
                            max="999"
                            :disabled="item.status != 'pending'"
                            v-model="detailPolicy.additionalDuration"
                          ></v-text-field>
                        </div>
                      </div>
                    </td>
                    <!-- <td>
											<span v-if="$route.query.sku_type === 'tutor' && sku">
												Theo buổi
											</span>
											<span v-if="$route.query.sku_type === 'duo' && sku">
												<span v-if="sku.durationType == 'month'">Theo tháng</span>
												<span v-if="sku.durationType == 'day'">Theo ngày</span>
											</span>
										</td> -->
                    <!-- <td class="text-center" v-if="$route.query.sku_type === 'duo'">
											<span v-if="!item.isEdit && sku">{{ item.additionalDuration || '--' }}</span>
											<v-text-field
												v-if="item.isEdit && sku && sku.durationType != 'day'"
                        class="text-field mt-5"
                        :clearable="true"
                        placeholder="Nhập thời hạn tặng thêm"
                        outlined
                        dense
												type="number"
												:disabled="item.status != 'pending'"
												min="0"
												v-model="item.additionalDuration"
                      ></v-text-field>
										</td> -->
                    <td
                      class="text-center"
                      v-if="$route.query.sku_type === 'tutor'"
                    >
                      <span v-if="!item.isEdit">{{
                        item.additionalNumOfLesson
                      }}</span>
                      <v-text-field
                        v-if="item.isEdit"
                        class="text-field mt-5 text-field-number"
                        :clearable="true"
                        placeholder="Nhập thời hạn tặng thêm"
                        outlined
                        dense
                        type="number"
                        :disabled="item.status != 'pending'"
                        min="0"
                        v-model="item.additionalNumOfLesson"
                      ></v-text-field>
                    </td>
                    <td>
                      <span v-if="item.status === 'pending'">Chưa bắt đầu</span>
                      <span v-if="item.status === 'active'">Đang áp dụng</span>
                      <span v-if="item.status === 'finished'">Đã kết thúc</span>
                      <span v-if="item.status === 'cancelled'">Đã hủy</span>
                    </td>
                    <td class="text-center">
                      {{ item.createdBy ? item.createdBy : "SYSTEM" }}
                    </td>
                    <td class="text-center">
                      <v-tooltip v-if="item.isEdit" bottom class="mr-2">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="#329D20"
                            v-bind="attrs"
                            v-on="on"
                            @click="saveItem(item, index)"
                          >
                            mdi-check-circle
                          </v-icon>
                        </template>
                        <span>Cập nhật</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="
                          !item.isEdit &&
                          ['pending', 'active'].includes(item.status)
                        "
                        bottom
                        class="mr-2"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="#329D20"
                            v-bind="attrs"
                            v-on="on"
                            @click="showEdit(item, index)"
                          >
                            mdi-check-circle
                          </v-icon>
                        </template>
                        <span>Cập nhật</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="item.status === 'pending'">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            class="ml-3 cursor-pointer"
                            color="#959595"
                            @click="cancelPolicy(item, index)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Hủy</span>
                      </v-tooltip>
                    </td>
                  </tr>
                  <tr v-if="data.length < 4" class="tr-no-data">
                    <td colspan="10"></td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="12" v-if="totalPage">
              <v-row>
                <v-col offset="4" cols="8" class="py-0">
                  <v-row>
                    <v-col cols="7" class="d-flex justify-end py-0">
                      <p class="pt-3">Rows per page:</p>
                    </v-col>
                    <v-col cols="1" class="justify-end py-0">
                      <v-select
                        class="text-field"
                        :items="[
                          { id: 10 },
                          { id: 20 },
                          { id: 30 },
                          { id: 40 },
                          { id: 50 },
                        ]"
                        item-value="id"
                        item-text="id"
                        :aLight="'right'"
                        placeholder="Chọn"
                        attach
                        dense
                        v-model="numPerPage"
                        @change="getList(1)"
                        :menu-props="{
                          top: true,
                          offsetY: true,
                          maxHeight: '150',
                        }"
                      ></v-select>
                    </v-col>
                    <v-col cols="1" class="justify-center py-0">
                      <p class="pt-3 text-center">
                        {{ (page - 1) * numPerPage + 1 }}-{{
                          (page - 1) * numPerPage + data.length
                        }}
                        of {{ totalItem }}
                      </p>
                    </v-col>
                    <v-col cols="3" class="py-0">
                      <v-pagination
                        v-model="page"
                        class="d-flex justify-end pagination-custom"
                        :length="totalPage"
                        :total-visible="7"
                        @input="getSkuPricePolicies()"
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </div>
  </div>
</template>

<script>
import * as moment from "moment";

import TokenService from "../../helpers/token";

import {
  productTypeDuo,
  productTypeTutor,
  productTypeCombo,
} from "../../helpers/constants";

import RepositoryFactory from "@/repositories/RepositoryFactory";
const ProductRepository = RepositoryFactory.get("product");

import Product from "./models/Product";
import SkuDuo from "./models/SkuDuo";
import SkuCombo from "./models/SkuCombo";
import SkuTutor from "@/pages/product-management/models/SkuTutor";
import { formatDate } from "@/helpers/utils";

export default {
  name: "detail-sku",
  components: {},
  props: {},
  data() {
    return {
      isEditable: false,
      keyRender: 0,
      startDate: null,
      endDate: null,
      priceType: null,
      minPrice: null,
      maxPrice: null,
      additionalDuration: null,
      product: new Product({}),
      productTypeDuo,
      productTypeTutor,
      productTypeCombo,
      data: [],
      productId: null,
      sku: null,
      skuPricePolicies: [],
      totalPage: 0,
      page: 1,
      numPerPage: 20,
      priceTypes: [
        {
          id: "custom",
          name: "Tùy chọn",
        },
        {
          id: "unchanged",
          name: "Cố định",
        },
      ],
      userId: null,
      totalItem: 0,
      subjectObj: {},
      comboPricePolicyDetails: [],
    };
  },
  computed: {
    currentDate() {
      return moment().format("YYYY-MM-DD");
    },
    isExistPending() {
      return !!this.data.find((item) => item.status === "pending");
    },
  },
  watch: {
    priceType(val) {
      if (val === "unchanged") {
        this.minPrice = this.sku.comboPrice;
      }
    },
  },
  async created() {
    if (this.$route.params.id) {
      await this.getDetail(this.$route.params.id);
      this.productId = parseInt(this.$route.params.id);
      this.getSkuPricePolicies();
    }
    this.userId = TokenService.getId();
    this.getListAttributes();
  },
  beforeDestroy() {},
  methods: {
    async getListAttributes() {
      const res = await ProductRepository.getProductAttributes();
      res.data.subjects.forEach((item) => {
        this.subjectObj[item.id] = item.name;
      });
    },
    isDisableEndDate(item) {
      console.log(
        "object,",
        !item.createdBy || ["finished", "cancelled"].includes(item.status)
      );
      return !item.createdBy || ["finished", "cancelled"].includes(item.status);
      // return false;
    },
    dateCus(data) {
      return moment(data).format("DD-MM-YYYY HH:mm");
    },
    compare(a, b) {
      if (b.id > a.id) {
        return 1;
      }
      if (a.id > b.id) {
        return -1;
      }
      return 0;
    },
    showEdit(item, index) {
      if (
        moment(item.endDate).isBefore(this.currentDate) ||
        item.status === "finished" ||
        !item.createdBy
      ) {
        return;
      }
      item.isEdit = true;
      this.keyRender++;
    },
    async saveItem(item, index) {
      if (!item.startDate) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Chưa chọn ngày bắt đầu",
        });
      }
      if (!item.priceType) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Chưa chọn loại giá bán",
        });
      }
      if (!item.minPrice) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Chưa nhập giá bán tối thiểu",
        });
      }
      if (item.minPrice && parseInt(item.minPrice) < 0) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối thiểu không được phép nhập số âm",
        });
      }
      if (item.maxPrice && parseInt(item.maxPrice) < 0) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối đa không được phép nhập số âm",
        });
      }
      if (item.minPrice && `${item.minPrice}`.includes(".")) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối thiểu chỉ được phép nhập số nguyên",
        });
      }

      if (item.minPrice && `${item.minPrice}`.length > 10) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối thiểu không được quá 10 kí tự",
        });
      }

      if (item.maxPrice && parseInt(item.minPrice) >= parseInt(item.maxPrice)) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối đa phải > giá bán tối thiểu",
        });
      }
      if (item.maxPrice && `${item.maxPrice}`.includes(".")) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối đa chỉ được phép nhập số nguyên",
        });
      }
      if (item.maxPrice && `${item.maxPrice}`.length > 10) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối đa không được quá 10 kí tự",
        });
      }
      if (item.priceType == "custom" && !item.maxPrice) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Chưa nhập giá bán tối đa",
        });
      }
      for (let i = 0; i < item.pricePolicyDetails.length; i++) {
        if (["tutor", "duo_month"].includes(item.type)) {
          if (
            (!item.pricePolicyDetails[i].additionalDuration &&
              item.pricePolicyDetails[i].additionalDuration != 0) ||
            `${item.pricePolicyDetails[i].additionalDuration}` === ""
          ) {
            return this.$swal({
              type: "error",
              title: "Lỗi !",
              text: "Chưa nhập thời hạn tăng thêm",
            });
          }
          if (
            item.pricePolicyDetails[i].additionalDuration &&
            parseInt(item.pricePolicyDetails[i].additionalDuration) < 0
          ) {
            return this.$swal({
              type: "error",
              title: "Lỗi !",
              text: "Thời hạn tăng thêm không cho phép nhập số âm",
            });
          }
          if (
            item.pricePolicyDetails[i].additionalDuration &&
            `${item.pricePolicyDetails[i].additionalDuration}`.length > 3
          ) {
            return this.$swal({
              type: "error",
              title: "Lỗi !",
              text: "Thời hạn tăng thêm không được quá 3 kí tự",
            });
          }
          if (
            item.pricePolicyDetails[i].additionalDuration &&
            `${item.pricePolicyDetails[i].additionalDuration}`.includes(".")
          ) {
            return this.$swal({
              type: "error",
              title: "Lỗi !",
              text: "Thời hạn tăng thêm chỉ được phép nhập số nguyên",
            });
          }
        }
      }
      if (item.endDate && moment(item.startDate).isSameOrAfter(item.endDate)) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Ngày kết thúc phải lớn hơn ngày bắt đầu",
        });
      }
      console.log("item", item.pricePolicyDetails);
      const comboPricePolicyDetails = item.pricePolicyDetails.map((itemD) => {
        return {
          itemType: itemD.itemType,
          itemId: itemD.itemId,
          additionalDuration: itemD.additionalDuration,
        };
      });
      const body = {
        skuType: this.$route.query.sku_type,
        skuId: this.$route.params.sku_id,
        startDate: moment(item.startDate).format("YYYY-MM-DD HH:mm"),
        endDate: item.endDate
          ? moment(item.endDate).format("YYYY-MM-DD HH:mm")
          : null,
        priceType: item.priceType,
        minPrice: (item.minPrice || item.minPrice === 0) ? parseInt(item.minPrice) : null,
        maxPrice: item.maxPrice ? parseInt(item.maxPrice) : null,
        comboPricePolicyDetails,
      };
      if (item.priceType != "custom") {
        delete body.maxPrice;
      }

      const res = await ProductRepository.updatePolicy(item.id, body);
      if (res && res.data) {
        this.$swal({
          type: "success",
          icon: "success",
          title: "Cập nhật thành công!",
          toast: true,
          showConfirmButton: false,
          timer: 1500,
        });
        this.getSkuPricePolicies();
        item.isEdit = false;
        this.keyRender++;
      } else {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: res.errors.message,
        });
      }
    },
    async getDetail(id) {
      const res = await ProductRepository.getDetail(id);
      this.product = new Product(res.data);
      this.getListSku();
    },
    async getListSku(search = {}) {
      this.skuItems = [];
      const params = {
        product_id: this.product.id,
        product_type: this.product.type,
        ...search,
      };
      const res = await ProductRepository.advanceSearchForCombo(params);
      this.sku = res.data.find((item) => item.id == this.$route.params.sku_id);
      const skuCheck = {};
      if (this.sku.skuTutors && this.sku.skuTutors.length) {
        this.sku.skuTutors.forEach((item) => {
          this.comboPricePolicyDetails.push({
            type: `tutor`,
            objectId: item.id,
            additionalDuration: null,
            code: item.code,
            name: item.name,
            typeTitle: "Gia sư",
            typeDuration: "Theo buổi",
          });
        });
      }
      if (this.sku.skuDuos && this.sku.skuDuos.length) {
        this.sku.skuDuos.forEach((item) => {
            this.comboPricePolicyDetails.push({
              type: `duo`,
              objectId: item.id,
              additionalDuration: null,
              typeTitle: "Khóa học",
              name: item.name,
              code: item.code,
              typeDuration: item.durationType == "day" ? "Theo ngày" : "Theo tháng",
            });
        });
      }
    },
    cancel() {
      // this.$swal
      // 	.fire({
      // 		title: "Bạn muốn đóng form? Tất cả thông tin sẽ bị mất!",
      // 		icon: "warning",
      // 		showCancelButton: true,
      // 		cancelButtonText: "Hủy",
      // 		confirmButtonColor: "#3085d6",
      // 		cancelButtonColor: "#d33",
      // 		confirmButtonText: "Đồng ý",
      // 	})
      // 	.then(async (result) => {
      // 		if (result?.value) {
      // 			this.$router.push("/products");
      // 		}
      // 	});
    },
    async cancelPolicy(item, index) {
      const body = {
        skuType: this.$route.query.sku_type,
        status: "cancelled",
      };
      const res = await ProductRepository.updateStatusPolicy(item.id, body);
      if (res && res.data) {
        this.$swal({
          type: "success",
          icon: "success",
          title: "Hủy thành công!",
          toast: true,
          showConfirmButton: false,
          timer: 1500,
        });
        this.getSkuPricePolicies();
      }
    },
    async getSkuPricePolicies() {
      const params = {
        sku_type: this.$route.query.sku_type,
        page: this.page,
        limit: this.numPerPage,
        sku_id: this.$route.params.sku_id,
      };
      const res = await ProductRepository.getSkuPricePolicies(params);
      this.data = res.data;
      this.totalPage = Math.ceil(res.totalItem / this.numPerPage);
      this.totalItem = res.totalItem;
      this.data.forEach((item) => {
        item.isEdit = false;
        item.startDate = new Date(item.startDate);
        if (item.endDate) {
          item.endDate = new Date(item.endDate);
        }
      });
    },
    async addPolicy() {
      if (!this.startDate) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Chưa chọn ngày bắt đầu",
        });
      }
      if (!this.priceType) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Chưa chọn loại giá bán",
        });
      }
      if (!this.minPrice && this.minPrice !== 0) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Chưa nhập giá bán tối thiểu",
        });
      }
      if (this.minPrice && `${this.minPrice}`.includes(".")) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối thiểu chỉ được phép nhập số nguyên",
        });
      }
      if (this.maxPrice && `${this.maxPrice}`.includes(".")) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối đa chỉ được phép nhập số nguyên",
        });
      }
      if (this.minPrice && parseInt(this.minPrice) < 0) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối thiểu không được phép nhập số âm",
        });
      }
      if (this.minPrice && `${this.minPrice}`.length > 10) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối thiểu không được quá 10 kí tự",
        });
      }
      if (this.maxPrice && `${this.maxPrice}`.length > 10) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối đa không được quá 10 kí tự",
        });
      }
      if (this.maxPrice && parseInt(this.maxPrice) < 0) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối đa không được phép nhập số âm",
        });
      }
      if (this.maxPrice && parseInt(this.minPrice) >= parseInt(this.maxPrice)) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Giá bán tối đa phải > giá bán tối thiểu",
        });
      }
      if (this.priceType == "custom" && !this.maxPrice) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Chưa nhập giá bán tối đa",
        });
      }
      for (let i = 0; i < this.comboPricePolicyDetails.length; i++) {
        if (
          ['"duo_month"', "tutor"].includes(
            this.comboPricePolicyDetails[i].type
          )
        ) {
          if (
            !this.comboPricePolicyDetails[i].additionalDuration &&
            this.comboPricePolicyDetails[i].additionalDuration != 0
          ) {
            return this.$swal({
              type: "error",
              title: "Lỗi !",
              text: "Chưa nhập thời hạn tăng thêm",
            });
          }
          if (
            this.comboPricePolicyDetails[i].additionalDuration &&
            parseInt(this.comboPricePolicyDetails[i].additionalDuration) < 0
          ) {
            return this.$swal({
              type: "error",
              title: "Lỗi !",
              text: "Thời hạn tăng thêm không cho phép nhập số âm",
            });
          }
          if (
            this.comboPricePolicyDetails[i].additionalDuration &&
            `${this.comboPricePolicyDetails[i].additionalDuration}`.length > 3
          ) {
            return this.$swal({
              type: "error",
              title: "Lỗi !",
              text: "Thời hạn tăng thêm không được quá 3 kí tự",
            });
          }
          if (
            this.comboPricePolicyDetails[i].additionalDuration &&
            `${this.comboPricePolicyDetails[i].additionalDuration}`.includes(
              "."
            )
          ) {
            return this.$swal({
              type: "error",
              title: "Lỗi !",
              text: "Thời hạn tăng thêm chỉ được phép nhập số nguyên",
            });
          }
        }
      }
      if (moment(this.currentDate).isAfter(this.startDate)) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Ngày bắt đầu phải lớn hơn thời điểm hiện tại",
        });
      }
      if (this.endDate && moment(this.startDate).isSameOrAfter(this.endDate)) {
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: "Ngày kết thúc phải lớn hơn ngày bắt đầu",
        });
      }
      const comboPricePolicyDetails = this.comboPricePolicyDetails.map(
        (item) => {
          const data = {
            itemType: item.type,
            itemId: item.objectId,
            additionalDuration: item.additionalDuration,
          };
          if (item.type === "duo_day") {
            delete data.additionalDuration;
          }

          return data;
        }
      );
      const body = {
        skuType: this.$route.query.sku_type,
        skuId: this.$route.params.sku_id,
        startDate: moment(this.startDate).format("YYYY-MM-DD HH:mm"),
        endDate: this.endDate
          ? moment(this.endDate).format("YYYY-MM-DD HH:mm")
          : null,
        priceType: this.priceType,
        minPrice: (this.minPrice || this.minPrice === 0) ? parseInt(this.minPrice) : null,
        maxPrice: this.maxPrice ? parseInt(this.maxPrice) : null,
        comboPricePolicyDetails: comboPricePolicyDetails,
      };

      if (this.priceType != "custom") {
        delete body.maxPrice;
      }

      const res = await ProductRepository.createPolicy(body);
      if (res && res.data) {
        this.$swal({
          type: "success",
          icon: "success",
          title: "Thêm thành công!",
          toast: true,
          showConfirmButton: false,
          timer: 1500,
        });
        this.getSkuPricePolicies();
        this.startDate = null;
        this.endDate = null;
        this.priceType = null;
        this.minPrice = null;
        this.maxPrice = null;
        this.comboPricePolicyDetails.forEach((item) => {
          item.additionalDuration = null;
        });
      } else {
        if (res.errors) {
          return this.$swal({
            type: "error",
            title: "Lỗi !",
            text: res.errors.message,
          });
        }
        return this.$swal({
          type: "error",
          title: "Lỗi !",
          text: res.message,
        });
      }
    },
	findSkuDetailById(item) {
	  if (item.itemType === "tutor") {
		return this.sku.skuTutors.find((sku) => sku.id === item.itemId);
	  }
	  if (item.itemType === "duo") {
		return this.sku.skuDuos.find((sku) => sku.id === item.itemId);
	  }
	},
  },
};
</script>
<style scoped lang="scss">
.btn-save {
  background: #8465ff !important;
  color: #fff;
}
.btn-cancel {
  background: #787878 !important;
  color: #fff;
}
.create-form {
  background: #fff;
}
.group-form {
  background: #fafbff;
  border-radius: 10px;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
}
.text-bold {
  font-weight: bold;
}

.btn-info {
  background: #6587ff !important;
  color: #fff;
}

.icon-search {
  left: 40px;
  position: relative;
}
.table-custom {
  th {
    background: #e7e8ff;
    border-left: 1px solid #fff;
  }
}
.table-policies {
  th {
    background: #e7e8ff;
    border-left: 1px solid #fff;
    font-size: 14px;
    font-weight: 500;
  }
}
.col-start {
  width: 200px;
}
.col-end {
  width: 200px;
}
.col-org-price {
  width: 150px;
}
.col-price-type {
  width: 150px;
}
.col-min-price {
  width: 200px;
}
.col-max-price {
  width: 200px;
}
.col-type {
  width: 150px;
}
.col-gift {
  width: 150px;
}
.col-status {
  width: 150px;
}
.col-create-by {
  width: 150px;
}
.col-action {
  width: 150px;
}
.col-product-type {
  width: 150px;
}
.col-sku-code {
  width: 150px;
}
.col-product-name {
  width: 250px;
}
.group-type-sku {
  width: 18%;
}
.group-name {
  width: 30%;
}
.group-code {
  width: 17%;
}
.group-type {
  width: 17%;
}
.group-additional {
  width: 18%;
}
.item-sku-detail {
  border-bottom: 1px solid #ccc;
}
</style>

<style lang="scss">
.text-field fieldset {
  background: #fff !important;
}
.text-search {
  .v-input__slot {
    min-height: 20px !important;
    padding-left: 35px !important;
  }
}

.v-select-custom-combo {
  .v-subheader {
    font-weight: bold;
    background: #ececec;
    color: #000;
  }

  width: 100px !important;
}

.group-bread-scrumb {
  position: relative;
  top: -30px;
  z-index: 99;
  height: 0;
  font-weight: bold;
  font-size: 17px;
  a {
    text-decoration: none !important;
    color: #000;
  }
}

.datetime-custom {
  width: 100%;
}
.pagination-custom {
  li button {
    box-shadow: none !important;
    color: #3f51b5 !important;
  }

  .v-pagination__item--active {
    color: #000 !important;
    background: #fff !important;
  }
}
.text-field-no-message {
  .v-text-field__details {
    display: none !important;
  }
}
</style>
<style lang="scss">
.table-policies {
  table {
    table-layout: fixed;
  }
}
</style>
